import * as d3 from "d3";
import {
    colonAnnotation,
    inrFormatter,
    wraps,
    make_x_gridlines,
    make_y_gridlines,
    createTooltip,
    generateDownloadData,
    contextMenu,
} from '../functions'
    export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {

        // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

        console.log("Chart vizName called:", vizName,filterParam);

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width + chart.margin.left + chart.margin.right)
            .attr('height', chart.height)
           // .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        // axios.post(url, filterParam).then(res => {
            let data = resData
            var axisLabelFontSize = chart.axisLabelFontSize + "px";
            var axisFontSize = chart.axisFontSize + "px";
            console.log("axisLabelFontSize",axisLabelFontSize);
            const jsonData = chart.x1AxisLabelCharLimitsJson;
            console.log("json data",jsonData);
            // Extract values into separate variables
            const charecter = jsonData.break.value1;
            const charecter1 = jsonData.break.value2;
            const value2RegExp = new RegExp(charecter1.slice(1, -1));

            var product_categories = d3.nest()
                .key(function (d) {
                    return d.dim2_name;
                })
                .entries(data);

            var county_categories = d3.nest()
                .key(function (d) {
                    return d.dim1_name;
                })
                .entries(data);
            data.forEach(function(d) {
                d.dim4_name = +d.dim4_name; // Unary plus to convert to number
            });
            var maxMetric3 = d3.max(data, function (d) { return d.metric1; });
            var minMetric3 = d3.min(data, function (d) { return d.metric1; });

            console.log("maxMetric3",maxMetric3,minMetric3)
            var radius = d3.scaleLinear()
                .domain([minMetric3, maxMetric3])
                .range([5, 25]);

         //   let numRows = county_categories.length;
            let numCols = product_categories.length;
            console.log("numCols",numCols);

        let size = Math.min(chart.width / numCols, 400);  // Set an upper limit to avoid excessive width


        county_categories.forEach((county, i) => {
                // Add title for the entire row
                console.log("hello", county_categories[i]);
                var name = county_categories[i].key
                svg.append('text')
                    .attr('x', chart.margin.left - 140)
                    .attr('y', i * size + chart.margin.top -70)
                    .style('text-anchor', 'middle')
                    .style('font-size', '16px')
                    .style('font-weight', 'bold')
                    .style('fill','blue')
                    .text(name);



                product_categories.forEach((product, j) => {
                    // let currentData = data.filter(d => d.dim1_name === county_categories[i].key && d.dim2_name === product_categories[j].key);
                    console.log("mmm", product)
                    let x1AxisLabel = data.filter(d => d.dim1_name === county_categories[i].key && d.dim2_name === product_categories[j].key)
                        .map(function (d) {
                            return d.dim3_name;
                        });

                    // let y1AxisLabel = data.filter(d => d.dim1_name === county_categories[i].key && d.dim2_name === product_categories[j].key)
                    //     .map(function (d) {
                    //         return d.dim4_name;
                    //     });

                    let x1Scale = d3.scaleBand()
                        .domain(x1AxisLabel)
                        .range([0, size - 2 * 40]);

                    var maxMetric1 = d3.max(data, function(d) {
                        return d.dim4_name });
                    var minMetric1 = d3.min(data, function(d) {
                        return d.dim4_name });

                    let y1Scale = d3.scaleLinear()
                        .domain([minMetric1, maxMetric1])
                        .range([size - 2 * 40,0]);  // Set max height to prevent excessive stretching

                    var tmp = svg.append('g')
                        .attr('transform', 'translate(' + (j * size) + ',' + (i * size) + ')'); // Adjust translation based on row and column

                    tmp.append('text')
                        .attr('x', size / 2 - 10) // Adjust the x position based on the chart size
                        .attr('y', -10) // Adjust the y position based on the chart size
                        .style('text-anchor', 'middle')
                        .style('font-size', '16px') // Adjust font size as needed
                        .style('font-weight', 'bold') // Adjust font weight as needed
                        .text(product.key);

                    // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
                    // var div = d3.select(divId).append('div').attr('class', 'tooltip')
                    //     .attr('style', 'position: absolute; opacity: 0;')

                    const tooltip = createTooltip(divId);

                    console.log("valuess", product_categories.values)

                    // Add circle
                    tmp.selectAll() // Use selectAll to select existing circles
                        .data(product_categories[j].values.sort((a, b) => b.metric1 - a.metric1))  // Use d.values instead of data
                        .enter()
                        .append('circle')
                        .attr('cx', (d) => {
                            // console.log("lll", d.dim3_name);
                            return x1Scale(d.dim3_name) + x1Scale.bandwidth() / 2;
                        })
                        .attr('cy', (d) => {
                            // console.log("sl", d.dim4_name);
                            return y1Scale(d.dim4_name);
                        })
                        .attr('r', (d) => radius(d.metric1)) // Adjust radius based on your data
                        .style('fill','#14cff4')//(d) => metric1ColorScale(d.metric1)
                        .style('opacity', 0.5)
                        .on('mouseover', function( d) {
                            tooltip.onMouseOver(d, this, function(d) {
                                // Tooltip content callback
                                return d.dim2_name
                                    + '<br>' + chart.x2MetricTooltip + colonAnnotation + county_categories[i].values[i].dim1_name
                                    + '<br>' + chart.x1MetricTooltip + colonAnnotation + d.dim3_name
                                    + '<br>' + chart.y1MetricTooltip + colonAnnotation + d.dim4_name
                                    + '<br>' + chart.y2MetricTooltip + colonAnnotation + inrFormatter(d.metric1)
                            });  // Pass the event for positioning
                        })
                        .on('mousemove', function(event) {
                            d3.select(this)
                                .style('stroke', 'gray') // Change border color on hover
                                .style('stroke-width', 2);
                            tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                        })
                        .on('mouseout', function() {
                            let circle = d3.select(this);
                            setTimeout(function() {
                                circle.style('stroke-width', 0);}, 2000);
                            tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
                        })
                        .on('contextmenu', function(d) {
                            console.log(d)
                            // Prepare clickedData with both axes' info
                            const clickedData = {
                                [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [county_categories[i].values[i].dim1_name], // e.g., "metric1"
                                [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name],
                                [chart.insightNavigator.realDataFieldNames.x2RealDataFieldName]:[d.dim3_name]
                            };
                            console.log("clickedData",clickedData);
                            // Generate the menu with current config and filters
                            const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                            // Show the context menu
                            contextMenu(menuItems).call(this, clickedData);

                            // Prevent default context menu
                            d3.event.preventDefault();
                        })


                    tmp.append('text')
                        .attr('x', size/2 - 40) // Adjust the x position based on the chart size
                        .attr('y', size + 20) // Adjust the y position based on the chart size
                        .style('text-anchor', 'middle')
                        .style('font-size', axisFontSize)
                        .style('font-weight', 'bold')
                        .text(chart.x1AxisDisplayName);
                    tmp.append('g')
                        .attr('transform', 'translate(' + 0 + ',' + (size - 40 * 2) + ')')
                        .call(d3.axisBottom(x1Scale)).style('font-size', axisLabelFontSize)
                        .selectAll('text')
                        .style('text-anchor', 'end')
                        .attr('dx', '-.6em')
                        .attr('dy','-.0em')
                        .attr('transform', 'rotate(-45)')
                        .call(wraps, charecter, value2RegExp);
                    // Y-axis Title
                    tmp.append('text')
                        .attr('transform', 'rotate(-90)')
                        .attr('y', -chart.margin.left + 40) // Adjust the y position based on the chart size
                        .attr('x', -size / 2 + 40) // Adjust the x position based on the chart size
                        .style('text-anchor', 'middle')
                        .style('font-size', axisFontSize)
                        .style('font-weight', 'bold')
                        .text(chart.y1AxisDisplayName);

                    tmp.append('g').call(d3.axisLeft(y1Scale)).style('font-size', axisLabelFontSize);
                    if (gridflag === true) {
                        // add the X gridlines
                        tmp.append("g")
                            .attr("class", "grid")
                            .attr("transform", "translate(0," + (size - 2 * 40) + ")")
                            .call(make_x_gridlines(x1Scale)
                                .tickSize(-(size - 2 * 40))
                                .tickFormat(""))
                            .style("stroke-width", 0.1)

                        // add the Y gridlines
                        tmp.append("g")
                            .attr("class", "grid")
                            .call(make_y_gridlines(y1Scale)
                                .tickSize(-(size - 2 * 40))
                                .tickFormat(""))
                            .style("stroke-width", 0.1)
                    }
            // .on('mouseover', y1tip.show)
            // .on('mouseout', y1tip.hide)
            // .on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
        })
    })
// })
}

